import API from 'js/lib/api';

const myFeedbackAPI = API('/api/myFeedback.v1', {
  type: 'rest',
});

export default myFeedbackAPI;
